import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton} from 'reactis-datagrid';
import {Button, ButtonToolbar,Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import NavBar from '../../components/NavBar';
import store from 'store2';

export default class List extends Component {

	constructor(props) {
		super(props);

		const rendererLink = (val, row) => {
			return <div>
					<a href={__URLPREFIX__ + '/emailtemplate/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>
				</div>
		};

		this.columnModel = [
			{
				name: 'title',
				title: 'Název',
				field: 'title',
				width: '30%',
				renderer: rendererLink
			},
			{
				name: 'subject',
				title: 'Předmět',
				field: 'subject',
				viewport: 'tablet'
			},
			{
				name: 'id',
				title: 'ID',
				field: 'id',
				width: 40,
				align: 'center',
				viewport: 'tablet'
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				style: {whiteSpace: 'nowrap'},
				width: 30,
				align: 'center',
				sortable: false,
				viewport: 'tablet',
				renderer: (val, row) => {
					return (
						<a href={__URLPREFIX__ + '/emailtemplate/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i><span className="vp-desktop">Upravit</span>
						</a>
					);
				}
			}
		];

		const filterSchema = {
			id: { class: FilterInput },
			fulltext: { class: SearchInput },
			title: { class: FilterInput },
			subject: { class: FilterInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-emailtemplate');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'title', 'direction': 'asc'};
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('emailtemplate.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('emailtemplate.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('emailtemplate', row.title, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		return (
			<div>
				<NavBar title="Notifikační šablony" />
				<Datagrid
					ref="datagrid"
					id="emailtemplate"
					api="emailtemplate.getList"
					filters={['fulltext']}
					filter={this.filter}
					saveState={true}
					columnModel={this.columnModel}
					defaultFilter={this.defaultFilter}
					defaultSort={this.defaultSort}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/containers/EmailTemplate/List.js